var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoyalty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.056 15.328L16.656 0.928C16.08 0.352 15.28 0 14.4 0H3.2C1.44 0 0 1.44 0 3.2V14.4C0 15.28 0.352 16.08 0.944 16.672L15.344 31.072C15.92 31.648 16.72 32 17.6 32C18.48 32 19.28 31.648 19.856 31.056L31.056 19.856C31.648 19.28 32 18.48 32 17.6C32 16.72 31.632 15.904 31.056 15.328ZM17.6 28.816L3.2 14.4V3.2H14.4V3.184L28.8 17.584L17.6 28.816ZM7.2 9.6C8.52548 9.6 9.6 8.52548 9.6 7.2C9.6 5.87452 8.52548 4.8 7.2 4.8C5.87452 4.8 4.8 5.87452 4.8 7.2C4.8 8.52548 5.87452 9.6 7.2 9.6ZM12 19.2C11.408 18.592 11.04 17.792 11.04 16.88C11.04 15.072 12.512 13.6 14.32 13.6C15.216 13.6 16.048 13.968 16.64 14.576L17.6 15.52L18.56 14.56C19.1847 13.9929 20.0037 13.6879 20.8472 13.7082C21.6907 13.7286 22.494 14.0727 23.0907 14.6693C23.6873 15.266 24.0314 16.0693 24.0518 16.9128C24.0722 17.7563 23.7671 18.5753 23.2 19.2L17.6 24.8L12 19.2Z",
    fill: "#0784F9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyalty);
export default __webpack_public_path__ + "static/media/loyalty.411f9e67428250212f57fafd1f01def2.svg";
export { ForwardRef as ReactComponent };